import VideoDetailPlayerSection from './VideoDetailPlayerSection';

export default VideoDetailPlayerSection;
export * from './types';
export { useVideoDetailPlayerSection } from './useVideoDetailPlayerSection'; 